import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import classes from "../styles/components/footer.module.scss";
import icon from "../images/icon.png";
import elements from "../styles/settings/elements.module.scss";
import { routes } from "../storage/constants/routes";
import { NavLink } from "react-router-dom";

function Footer() {
    return (
        <Container>
            <hr className={classes.hrDivider} />
            <Row className={`${classes.footer} align-items-center`}>
                {/* Left Column: Icon and Text */}
                <Col xs={12} md={8}>
                    <div className={classes.leftCol}>
                        <img src={icon} alt="Icon" className={classes.icon} />
                        <p className={classes.text}>
                            Your free access to best tools and interactive games
                        </p>
                    </div>
                </Col>
                {/* Right Column: Remove Ads Button and Policy Links */}
                <Col xs={12} md={4}>
                    <div className={classes.rightCol}>
                        {/*<Button className={`${elements.button} ${classes.button}`}>*/}
                        {/*    Remove Ads*/}
                        {/*</Button>*/}
                        <div className={classes.linksContainer}>
                            <NavLink to={routes.termsAndConditions} className={classes.link}>
                                Terms and Conditions
                            </NavLink>
                            <NavLink to={routes.privacyPolicy} className={classes.link}>
                                Privacy Policy
                            </NavLink>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Footer;